import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { WalletConnectIcon } from '@dynamic-labs/iconic';
import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import '../../../config/LSSuffix.js';
import '@dynamic-labs/wallet-connector-core';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import { ReactComponent as SvgWalletOutline } from '../../../shared/assets/wallet-outline.js';
import { ReactComponent as SvgFooterInfoIcon } from '../../../shared/assets/footer-info-icon.js';
import '@dynamic-labs/utils';
import '../../constants/colors.js';
import 'ethers';
import '../../../shared/consts/index.js';

const getDynamicLayoutData = ({ view }) => {
    if (view === 'no-access') {
        const headerData = {
            heading: "You don't have access",
        };
        return { headerData };
    }
    const footerMap = {
        'login-with-email-or-wallet-full-wallet-list': {
            heading: 'Get your first wallet',
            icon: jsx(SvgWalletOutline, {}),
        },
        'pending-connect': {
            heading: 'Learn about connecting your wallet',
            icon: jsx(SvgFooterInfoIcon, {}),
        },
        'pending-signature': {
            heading: 'Learn about signing / logging in',
            icon: jsx(SvgFooterInfoIcon, {}),
        },
        'pending-signature-without-back-button': {
            heading: 'Learn about signing / logging in',
            icon: jsx(SvgFooterInfoIcon, {}),
        },
        'qr-code': {
            heading: 'Learn about connecting your wallet',
            icon: jsx(SvgFooterInfoIcon, {}),
        },
        'wallet-connect-mobile-wallets-list': {
            heading: 'Get your first wallet',
            icon: jsx(SvgWalletOutline, {}),
        },
        'wallet-list': {
            heading: 'Get your first wallet',
            icon: jsx(SvgWalletOutline, {}),
        },
    };
    const headerMap = {
        'chainalysis-blocked-wallet': {
            heading: 'Access denied',
        },
        'login-with-email-or-wallet': { heading: 'Sign in / Sign up' },
        'login-with-email-or-wallet-full-wallet-list': {
            heading: 'Select your wallet',
        },
        'wallet-connect-mobile-wallets-list': {
            heading: (jsxs(Fragment, { children: [jsx(WalletConnectIcon, { style: { height: '1.5rem', width: '1.5rem' } }), ' ', "WalletConnect wallets"] })),
        },
        'wallet-list': { heading: 'Select your wallet' },
        'wallet-sign': { heading: 'Sign to confirm transfer' },
    };
    const footerData = footerMap[view];
    const headerData = headerMap[view];
    return {
        footerData,
        headerData,
    };
};

export { getDynamicLayoutData };
